import { Tabs } from "@shared/ui/tabs";
import { ServicesSettings } from "./servicesSettings";
import { ComplaintsSettings } from "./complaintsSettings";
import { PaymentSettings } from "./paymentSettings/paymentSettings";
import { OperationalSLASettings } from "./operationalSLASettings";
import { NewConnectionLanding } from "./newConnection/landing/landing";

const SettingsLanding = () => {
  const tabComponents = {
    newConnection: {
      label: "New Connection",
      shortLabel: "New Connection",
      component: <NewConnectionLanding />,
    },
    services: {
      label: "Services",
      shortLabel: "Services",
      component: <ServicesSettings />,
    },
    complaints: {
      label: "Complaints",
      shortLabel: "Complaints",
      component: <ComplaintsSettings />,
    },
    payment: {
      label: "Payment",
      shortLabel: "Payment",
      component: <PaymentSettings />,
    },
    operationalSLA: {
      label: "Operational SLA",
      shortLabel: "Operational SLA",
      component: <OperationalSLASettings />,
    },
  };

  const urlMapping = {
    newConnection: "new-connection",
    services: "services",
    complaints: "complaints",
    payment: "payment",
    operationalSLA: "operational-sla",
  };

  return (
    <div className="flex flex-col gap-5">
        <div>
          <p className="page-title">Settings</p>
          <p className="page-subtitle">
            Manage and configure system-wide settings to customize your
            application's behavior and user experience.
          </p>
        </div>

      <Tabs
        defaultValue="newConnection"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-5 mb-6"
        idPrefix="settings-tab"
        level={0} // Top-level tabs
      />
    </div>
  );
};

export default SettingsLanding;
